
import { Component, Prop, Vue } from "vue-property-decorator";
import NavBar from "./header.vue"
@Component({
  components: {
    NavBar
  }
})
export default class Logout extends Vue {
  @Prop({ default: {}, type: Object }) public data;

  public message = "";
  public updataImg() {
    this.$dialog.alert({
      message: '确定要删除这张图片?',
      showCancelButton: true,
      confirmButtonColor: '#000',
    }).then(() => {
      this.$emit('confirmDelImg', this.data.id)
    })
  }
  public onClose(event) {
    this.$emit("confirmDelImg", event);
  }
  public onSumbit() {
    this.$dialog.alert({
      message: '提交反馈成功，谢谢您的反馈',
      confirmButtonColor: '#000',
    });
  }
}
